import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["role"]
const _hoisted_2 = ["role"]

import type { Options } from "@/types";

import MdcChip from "@/components/Mdc/MdcChip.vue";

interface Props {
    list: Options[];
    activeChips?: null | string | string[] | number | number[];
    setRole?: string;
    chipsRole?: string;
    justifyContent?: "center" | "flex-start" | "flex-end" | "space-between";
    alignItems?: "center" | "flex-start" | "flex-end";
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MdcChips',
  props: {
    list: {},
    activeChips: { default: null },
    setRole: { default: "grid" },
    chipsRole: { default: "presentation" },
    justifyContent: { default: "center" },
    alignItems: { default: "center" }
  },
  emits: ["update"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

function emitUpdate(val: string | number): void {
    if (Array.isArray(props.activeChips)) {
        let res = props.activeChips.slice(0) as string[] | number[];
        let valIndex = res.indexOf(val as never);
        valIndex === -1 ? res.push(val as never) : res.splice(valIndex, 1);
        emit("update", res);
    } else {
        emit("update", val);
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: "mdc-evolution-chip-set",
    role: props.setRole
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["mdc-evolution-chip-set__chips", {
                'justify-content-start': props.justifyContent === 'flex-start',
                'justify-content-end': props.justifyContent === 'flex-end',
                'justify-content-between':
                    props.justifyContent === 'space-between',
                'align-items-start': props.alignItems === 'flex-start',
                'align-items-end': props.alignItems === 'flex-end',
            }]),
      role: props.chipsRole
    }, [
      (props.list)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(props.list, (chip, index) => {
            return (_openBlock(), _createBlock(MdcChip, {
              key: index,
              label: chip.label,
              value: chip.value,
              active: 
                    props.activeChips === null
                        ? null
                        : Array.isArray(props.activeChips)
                        ? props.activeChips.indexOf(chip.value) !== -1
                        : props.activeChips === chip.value
                ,
              onClick: ($event: any) => (emitUpdate(chip.value))
            }, null, 8, ["label", "value", "active", "onClick"]))
          }), 128))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ], 10, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})